import React, { useEffect, useState } from 'react';

import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Link,
} from '@material-ui/core';

export const KaapCabInform = (props: FieldExtensionComponentProps<boolean>) => {
  const {
    onChange,
    schema: { title = 'CAB: Inform clients' },
    formData,
    formContext,
    required,
    rawErrors,
    disabled,
    idSchema,
  } = props;

  const description =
    'Inform application clients about potential disruptions during KaaP upgrades 5 days ahead.';
  const hasValue = typeof formData === 'boolean';
  const [wasChangedByUser, setWasChangedByUser] = useState(hasValue);

  const selectedTier = (formContext as Record<string, any>)?.formData
    ?.clusterSelection?.tier;

  useEffect(() => {
    if (wasChangedByUser) {
      return;
    }

    if (selectedTier !== 'external') {
      onChange(false);
      return;
    }

    onChange(selectedTier === 'external');
  }, [selectedTier, onChange, wasChangedByUser]);

  const currentValue = hasValue ? formData : selectedTier === 'external';

  if (selectedTier !== 'external' || !selectedTier) {
    return null;
  }

  return (
    <FormControl error={Boolean(rawErrors?.length)}>
      <FormControlLabel
        control={
          <Checkbox
            id={idSchema?.$id}
            checked={Boolean(currentValue)}
            onChange={event => {
              setWasChangedByUser(true);
              onChange(event.target.checked);
            }}
            disabled={Boolean(disabled)}
          />
        }
        label={title}
      />
      {description && (
        <FormHelperText>
          <span>
            {description}{' '}
            <Link
              target="_blank"
              href="https://frontstage.tomtomgroup.com/docs/default/component/kaap-documentation/guardrails#cab-inform-clients"
            >
              More details.
            </Link>
          </span>
        </FormHelperText>
      )}
      {rawErrors?.map(err => (
        <FormHelperText key={err} error>
          {err}
        </FormHelperText>
      ))}
      {required && (
        <input type="hidden" value={String(Boolean(currentValue))} />
      )}
    </FormControl>
  );
};
